import { CONFIG_SLICE_NAME } from '../slicesNames';

export const api = (state) => state[CONFIG_SLICE_NAME].values.API_TOKEN;
export const azureMaps = (state) => state[CONFIG_SLICE_NAME].values.AZURE_MAPS_KEY;
